module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAc0lEQVR42u3aMQHAIBAEwbeCkPg3gAeIikPITbEGpt5JMs0NAAAAAAAAAAAAAADlAP89aQoAAAAAAAAAAAAAAAAAAAAAAAAAgHaAvb40BQAAAAAAAAAAAAAAAAAAAAAAAABAO4BTFAAAAAAAAAAAAACAqh7VV35ilNMcnQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Poland.png
// module id = +Rzk
// module chunks = 0 62 63